module.exports = __webpack_public_path__ + "static/img/14000062.41353736.png";